module.exports = require("./sq-MK");